import useTranslation from 'next-translate/useTranslation';

// Components
import Modal from '@/components/base/Modal';
import Button from '@/components/base/Button';

export const DataAccessLogoutModal = ({
    isOpen,
    toggle,
    logout,
    logoutLoading
}: {
    isOpen: boolean;
    toggle: () => void;
    logout: () => void;
    logoutLoading: boolean;
}) => {
    const { t } = useTranslation('settings');

    return (
        <Modal open={isOpen} onDismiss={toggle}>
            <Modal.Body>
                <Modal.Title>{t('data_access_page.logout_modal.title')}</Modal.Title>
                <Modal.Content className="pt-8 text-center text-sm">
                    {t('data_access_page.logout_modal.content')}
                </Modal.Content>
            </Modal.Body>
            <Modal.Footer className="my-8 flex justify-center space-x-6">
                <Button onClick={logout} isLoading={logoutLoading}>
                    {t('data_access_page.logout_modal.yes_log_out')}
                </Button>
                <Button variant="secondary" onClick={toggle}>
                    {t('commons:cancel')}
                </Button>
            </Modal.Footer>
        </Modal>
    );
};
